const country = [
    {"image":"afuhan.gif","name":"Afghanistan","id":"AF","cid":"1"},
    {"image":"arbny.gif","name":"Albania","id":"AL","cid":"2"},
    {"image":"arjly.gif","name":"Algeria","id":"DZ","cid":"5"},
    {"image":"andaor.gif","name":"Andorra","id":"AD","cid":"2"},
    {"image":"angla.gif","name":"Angola","id":"AO","cid":"5"},
    {"image":"bbd.gif","name":"Antigua and Barbuda","id":"AG","cid":"3"},
    {"image":"flg_argentina_sm.gif","name":"Argentina","id":"AR","cid":"4"},
    {"image":"yameiniya.gif","name":"Armenia","id":"AM","cid":"1"},
    {"image":"flg_australia_sm.gif","name":"Australia","id":"AU","cid":"6"},
    {"image":"flg_austria_sm.gif","name":"Austria","id":"AT","cid":"2"},
    {"image":"asaibaijiang.gif","name":"Azerbaijan","id":"AZ","cid":"1"},
    {"image":"bahama.gif","name":"Bahamas","id":"BS","cid":"3"},
    {"image":"balin.gif","name":"Bahrain","id":"BH","cid":"1"},
    {"image":"memgjiala.gif","name":"Bangladesh","id":"BD","cid":"1"},
    {"image":"babaduosi.gif","name":"Barbados","id":"BB","cid":"3"},
    {"image":"baie.gif","name":"Belarus","id":"BY","cid":"2"},
    {"image":"bilishi.gif","name":"Belgium","id":"BE","cid":"2"},
    {"image":"blz.gif","name":"Belize","id":"BZ","cid":"3"},
    {"image":"beinin.gif","name":"Benin","id":"BJ","cid":"5"},
    {"image":"budan.gif","name":"Bhutan","id":"BT","cid":"1"},
    {"image":"flg_bolivia_sm.gif","name":"Bolivia","id":"BO","cid":"4"},
    {"image":"bociwana.gif","name":"Botswana","id":"BW","cid":"5"},
    {"image":"flg_brazil_sm.gif","name":"Brazil","id":"BR","cid":"4"},
    {"image":"wenlai.gif","name":"Brunei","id":"BN","cid":"1"},
    {"image":"baojly.gif","name":"Bulgaria","id":"BG","cid":"2"},
    {"image":"bjnfs.gif","name":"Burkina","id":"BF","cid":"5"},
    {"image":"bulongdi.gif","name":"Burundi","id":"BI","cid":"5"},
    {"image":"jianpuzai.gif","name":"Cambodia","id":"KH","cid":"1"},
    {"image":"kamailong.gif","name":"Cameroon","id":"CM","cid":"5"},
    {"image":"flg_canada_sm.gif","name":"Canada","id":"CA","cid":"3"},
    {"image":"fodej.gif","name":"Cape Verde","id":"CV","cid":"5"},
    {"image":"zhongfei.gif","name":"Central African Republic","id":"CF","cid":"5"},
    {"image":"zhade.gif","name":"Chad","id":"TD","cid":"5"},
    {"image":"flg_chile_sm.gif","name":"Chile","id":"CL","cid":"4"},
    {"image":"flg_china_sm.gif","name":"China","id":"CN","cid":"1"},
    {"image":"flg_colombia_sm.gif","name":"Colombia","id":"CO","cid":"4"},
    {"image":"kemoluo.gif","name":"Comoros","id":"KM","cid":"5"},
    {"image":"flg_costarica_sm.gif","name":"Costa Rica","id":"CR","cid":"3"},
    {"image":"kldy.gif","name":"Croatia","id":"HR","cid":"2"},
    {"image":"guba.gif","name":"Cuba","id":"CU","cid":"3"},
    {"image":"saipulusi.gif","name":"Cyprus","id":"CY","cid":"1"},
    {"image":"jieke.gif","name":"Czech Republic","id":"CZ","cid":"2"},
    {"image":"minzhugg.gif","name":"Democratic Republic of the Congo","id":"CD","cid":"5"},
    {"image":"danmai.gif","name":"Denmark","id":"DK","cid":"2"},
    {"image":"jibuti.gif","name":"Djibouti","id":"DJ","cid":"5"},
    {"image":"dmnike.gif","name":"Dominica","id":"DM","cid":"3"},
    {"image":"duominijia.gif","name":"Dominican Republic","id":"DO","cid":"3"},
    {"image":"egde.gif","name":"Ecuador","id":"EC","cid":"4"},
    {"image":"aiji.gif","name":"Egypt","id":"EG","cid":"5"},
    {"image":"flg_elsavador_sm.gif","name":"El Salvador","id":"SV","cid":"3"},
    {"image":"chdjny.gif","name":"Equatorial Guinea","id":"GQ","cid":"5"},
    {"image":"eltly.gif","name":"Eritrea","id":"ER","cid":"5"},
    {"image":"aishny.gif","name":"Estonia","id":"EE","cid":"2"},
    {"image":"aiseby.gif","name":"Ethiopia","id":"ET","cid":"5"},
    {"image":"feiji.gif","name":"Fiji","id":"FJ","cid":"6"},
    {"image":"fenlan.gif","name":"Finland","id":"FI","cid":"2"},
    {"image":"flg_france_sm.gif","name":"France","id":"FR","cid":"2"},
    {"image":"jiapeng.gif","name":"Gabon","id":"GA","cid":"5"},
    {"image":"gbya.gif","name":"Gambia","id":"GM","cid":"5"},
    {"image":"gelujiya.gif","name":"Georgia","id":"GE","cid":"1"},
    {"image":"flg_germany_sm.gif","name":"Germany","id":"DE","cid":"2"},
    {"image":"jiana.gif","name":"Ghana","id":"GH","cid":"5"},
    {"image":"xila.gif","name":"Greece","id":"GR","cid":"2"},
    {"image":"gelinnada.gif","name":"Grenada","id":"GD","cid":"3"},
    {"image":"flg_guetamala_sm.gif","name":"Guatemala","id":"GT","cid":"3"},
    {"image":"jineiya.gif","name":"Guinea","id":"GN","cid":"5"},
    {"image":"bishao.gif","name":"Guinea-Bissau","id":"GW","cid":"5"},
    {"image":"guiyana.gif","name":"Guyana","id":"GY","cid":"4"},
    {"image":"haidi.gif","name":"Haiti","id":"HT","cid":"3"},
    {"image":"flg_honduras_sm.gif","name":"Honduras","id":"HN","cid":"3"},
    {"image":"xyl.gif","name":"Hungary","id":"HU","cid":"2"},
    {"image":"bingdao.gif","name":"Iceland","id":"IS","cid":"2"},
    {"image":"yindu.gif","name":"India","id":"IN","cid":"1"},
    {"image":"yinni.gif","name":"Indonesia","id":"ID","cid":"1"},
    {"image":"yilang.gif","name":"Iran","id":"IR","cid":"1"},
    {"image":"yilake.gif","name":"Iraq","id":"IQ","cid":"1"},
    {"image":"airlan.gif","name":"Ireland","id":"IE","cid":"2"},
    {"image":"yiselie.gif","name":"Israel","id":"IL","cid":"1"},
    {"image":"ydl.gif","name":"Italy","id":"IT","cid":"2"},
    {"image":"ketediwa.gif","name":"Ivory Coast","id":"CI","cid":"5"},
    {"image":"yamaijia.gif","name":"Jamaica","id":"JM","cid":"3"},
    {"image":"riben.gif","name":"Japan","id":"JP","cid":"1"},
    {"image":"yuedan.gif","name":"Jordan","id":"JO","cid":"1"},
    {"image":"hasakesitan.gif","name":"Kazakhstan","id":"KZ","cid":"1"},
    {"image":"keniya.gif","name":"Kenya","id":"KE","cid":"5"},
    {"image":"jlbs.gif","name":"Kiribati","id":"KI","cid":"6"},
    {"image":"keweite.gif","name":"Kuwait","id":"KW","cid":"1"},
    {"image":"jiererjisitan.gif","name":"Kyrgyzstan","id":"KG","cid":"1"},
    {"image":"laowo.gif","name":"Laos","id":"LA","cid":"1"},
    {"image":"latwy.gif","name":"Latvia","id":"LV","cid":"2"},
    {"image":"libaneng.gif","name":"Lebanon","id":"LB","cid":"1"},
    {"image":"laisuotuo.gif","name":"Lesotho","id":"LS","cid":"5"},
    {"image":"libiliya.gif","name":"Liberia","id":"LR","cid":"5"},
    {"image":"libia.gif","name":"Libya","id":"LY","cid":"5"},
    {"image":"liezdsd.gif","name":"Liechtenstein","id":"LI","cid":"2"},
    {"image":"litaow.gif","name":"Lithuania","id":"LT","cid":"2"},
    {"image":"lusbao.gif","name":"Luxembourg","id":"LU","cid":"2"},
    {"image":"maqidun.gif","name":"Macedonia","id":"MK","cid":"2"},
    {"image":"mdjsj.gif","name":"Madagascar","id":"MG","cid":"5"},
    {"image":"malawei.gif","name":"Malawi","id":"MW","cid":"5"},
    {"image":"malaixiya.gif","name":"Malaysia","id":"MY","cid":"1"},
    {"image":"maerdaifu.gif","name":"Maldives","id":"MV","cid":"1"},
    {"image":"mali.gif","name":"Mali","id":"ML","cid":"5"},
    {"image":"mart.gif","name":"Malta","id":"MT","cid":"2"},
    {"image":"flg_mashr.gif","name":"Marshall islands","id":"MH","cid":"6"},
    {"image":"mltny.gif","name":"Mauritania","id":"MR","cid":"5"},
    {"image":"mlqs.gif","name":"Mauritius","id":"MU","cid":"5"},
    {"image":"flg_mexico_sm.gif","name":"Mexico","id":"MX","cid":"3"},
    {"image":"mklnxy.gif","name":"Micronesia","id":"FM","cid":"6"},
    {"image":"mordw.gif","name":"Moldova","id":"MD","cid":"2"},
    {"image":"monage.gif","name":"Monaco","id":"MC","cid":"2"},
    {"image":"menggu.gif","name":"Mongolia","id":"MN","cid":"1"},
    {"image":"molog.gif","name":"Morocco","id":"MA","cid":"5"},
    {"image":"msbk.gif","name":"Mozambique","id":"MZ","cid":"5"},
    {"image":"miandian.gif","name":"Myanmar","id":"MM","cid":"1"},
    {"image":"nmby.gif","name":"Namibia","id":"NA","cid":"5"},
    {"image":"naolu.gif","name":"Nauru","id":"NR","cid":"6"},
    {"image":"niboer.gif","name":"Nepal","id":"NP","cid":"1"},
    {"image":"flg_netherlands_sm.gif","name":"Netherlands","id":"NL","cid":"2"},
    {"image":"flg_newzealand_sm.gif","name":"New Zealand","id":"NZ","cid":"6"},
    {"image":"flg_nicaragua_sm.gif","name":"Nicaragua","id":"NI","cid":"3"},
    {"image":"nirir.gif","name":"Niger","id":"NE","cid":"5"},
    {"image":"niriliya.gif","name":"Nigeria","id":"NG","cid":"5"},
    {"image":"chaoxian.gif","name":"North Korea","id":"KP","cid":"1"},
    {"image":"nuowei.gif","name":"Norway","id":"NO","cid":"2"},
    {"image":"aman.gif","name":"Oman","id":"OM","cid":"1"},
    {"image":"bajisitan.gif","name":"Pakistan","id":"PK","cid":"1"},
    {"image":"palao.gif","name":"Palau","id":"PW","cid":"6"},
    {"image":"balesitan.gif","name":"Palestinian Territory","id":"PS","cid":"1"},
    {"image":"flg_panama_sm.gif","name":"Panama","id":"PA","cid":"3"},
    {"image":"baxi.gif","name":"Papua New Guinea","id":"PG","cid":"6"},
    {"image":"balagui.gif","name":"Paraguay","id":"PY","cid":"4"},
    {"image":"flg_peru_sm.gif","name":"Peru","id":"PE","cid":"4"},
    {"image":"feilubing.gif","name":"Philippines","id":"PH","cid":"1"},
    {"image":"bolan.gif","name":"Poland","id":"PL","cid":"2"},
    {"image":"flg_portugal_sm.gif","name":"Portugal","id":"PT","cid":"2"},
    {"image":"kataer.gif","name":"Qatar","id":"QA","cid":"1"},
    {"image":"gangguo.gif","name":"Republic of the Congo","id":"CG","cid":"5"},
    {"image":"flg_romania_sm.gif","name":"Romania","id":"RO","cid":"2"},
    {"image":"eluosi.gif","name":"Russia","id":"RU","cid":"2"},
    {"image":"luwangda.gif","name":"Rwanda","id":"RW","cid":"5"},
    {"image":"sjchnws.gif","name":"Saint Kitts and Nevis","id":"KN","cid":"3"},
    {"image":"slxy.gif","name":"Saint Lucia","id":"LC","cid":"3"},
    {"image":"swensente.gif","name":"Saint Vincent and the Grenadines","id":"VC","cid":"3"},
    {"image":"samoya.gif","name":"Samoa","id":"WS","cid":"6"},
    {"image":"sanmalino.gif","name":"San Marino","id":"SM","cid":"2"},
    {"image":"sdmhplxb.gif","name":"Sao Tome and Principe","id":"ST","cid":"5"},
    {"image":"shate.gif","name":"Saudi Arabia","id":"SA","cid":"1"},
    {"image":"snjer.gif","name":"Senegal","id":"SN","cid":"5"},
    {"image":"saisher.gif","name":"Seychelles","id":"SC","cid":"5"},
    {"image":"sllang.gif","name":"Sierra Leone","id":"SL","cid":"5"},
    {"image":"xinjiapo.gif","name":"Singapore","id":"SG","cid":"1"},
    {"image":"slfk.gif","name":"Slovakia","id":"SK","cid":"2"},
    {"image":"slwny.gif","name":"Slovenia","id":"SI","cid":"2"},
    {"image":"suoluomen.gif","name":"Solomon Islands","id":"SB","cid":"6"},
    {"image":"suomali.gif","name":"Somalia","id":"SO","cid":"5"},
    {"image":"nanfei.gif","name":"South Africa","id":"ZA","cid":"5"},
    {"image":"hanguo.gif","name":"South Korea","id":"KR","cid":"1"},
    {"image":"flg_spain_sm.gif","name":"Spain","id":"ES","cid":"2"},
    {"image":"sililanka.gif","name":"Sri Lanka","id":"LK","cid":"1"},
    {"image":"sudan.gif","name":"Sudan","id":"SD","cid":"5"},
    {"image":"sulinan.gif","name":"Suriname","id":"SR","cid":"4"},
    {"image":"swshlan.gif","name":"Swaziland","id":"SZ","cid":"5"},
    {"image":"ruidian.gif","name":"Sweden","id":"SE","cid":"2"},
    {"image":"ruishi.gif","name":"Switzerland","id":"CH","cid":"2"},
    {"image":"xuliya.gif","name":"Syria","id":"SY","cid":"1"},
    {"image":"tajikesitan.gif","name":"Tajikistan","id":"TJ","cid":"1"},
    {"image":"tsny.gif","name":"Tanzania","id":"TZ","cid":"5"},
    {"image":"taiguo.gif","name":"Thailand","id":"TH","cid":"1"},
    {"image":"duoge.gif","name":"Togo","id":"TG","cid":"5"},
    {"image":"tangjia.gif","name":"Tonga","id":"TO","cid":"6"},
    {"image":"dbg.gif","name":"Trinidad and Tobago","id":"TT","cid":"3"},
    {"image":"tunis.gif","name":"Tunisia","id":"TN","cid":"5"},
    {"image":"tuerqi.gif","name":"Turkey","id":"TR","cid":"1"},
    {"image":"tukumansitan.gif","name":"Turkmenistan","id":"TM","cid":"1"},
    {"image":"tuwalu.gif","name":"Tuvalu","id":"TV","cid":"6"},
    {"image":"wgd.gif","name":"Uganda","id":"UG","cid":"5"},
    {"image":"wukelan.gif","name":"Ukraine","id":"UA","cid":"2"},
    {"image":"alianqiu.gif","name":"United Arab Emirates","id":"AE","cid":"1"},
    {"image":"flg_uk_sm.gif","name":"United Kingdom","id":"GB","cid":"2"},
    {"image":"flg_usa_sm.gif","name":"United States","id":"US","cid":"3"},
    {"image":"flg_uruguay_sm.gif","name":"Uruguay","id":"UY","cid":"4"},
    {"image":"wuzibieke.gif","name":"Uzbekistan","id":"UZ","cid":"1"},
    {"image":"wnat.gif","name":"Vanuatu","id":"VU","cid":"6"},
    {"image":"fandigang.gif","name":"Vatican","id":"VA","cid":"2"},
    {"image":"flg_venezuela_sm.gif","name":"Venezuela","id":"VE","cid":"4"},
    {"image":"yuenan.gif","name":"Vietnam","id":"VN","cid":"1"},
    {"image":"yemen.gif","name":"Yemen","id":"YE","cid":"1"},
    {"image":"zanbiya.gif","name":"Zambia","id":"ZM","cid":"5"},
    {"image":"jbbw.gif","name":"Zimbabwe","id":"ZW","cid":"5"}
];
export default country;